/*
Site Toast
*/

function showSiteToast(message) {
  let toast = document.querySelector('.site-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className =
      'site-toast fixed top-4 left-1/2 -translate-x-1/2 z-50 bg-black text-white font-body-bold px-6 py-3 opacity-0 pointer-events-none transition-opacity duration-300';
    toast.setAttribute('role', 'status');
    document.body.appendChild(toast);
  }

  toast.textContent = message;
  toast.classList.remove('opacity-0');
  clearTimeout(toast._hideTimeout);
  toast._hideTimeout = setTimeout(() => {
    toast.classList.add('opacity-0');
  }, 2500);
}

/*
Login Form
*/

class LoginForm extends HTMLElement {
  constructor() {
    super();
    this.forgotPass();
  }
  forgotPass() {
    const loginForm = this.querySelector('.login-form');
    const recoverForm = this.querySelector('.recover-form');
    const recoverBtn = this.querySelector('.recover-button');
    const closeBtn = this.querySelector('.close-button');

    recoverBtn.addEventListener('click', () => {
      recoverForm.style.display = 'grid';
      loginForm.style.display = 'none';
    });
    closeBtn.addEventListener('click', () => {
      recoverForm.style.display = 'none';
      loginForm.style.display = 'grid';
    });
  }
}

customElements.define('login-form', LoginForm);

/*
Account Menu
*/

class AccountMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let currentUrl = window.location.href;
    const currentFragment = new URL(currentUrl).hash;
    if (currentFragment.substring(1) != '') {
      toggleSection(currentFragment.substring(1));
    }

    const buttons = this.querySelectorAll('[data-menu="button"]');
    buttons.forEach((button) => {
      const buttonURL = button.querySelector('a').href;
      const fragment = new URL(buttonURL).hash;
      const key = fragment.substring(1);

      if (currentFragment.substring(1) != '') {
        if (currentFragment.substring(1) === key) {
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      }

      button.addEventListener('click', () => {
        buttons.forEach((button) => {
          button.classList.remove('active');
        });
        button.classList.add('active');
        toggleSection(key);
      });
    });

    function toggleSection(key) {
      const sections = document.querySelectorAll('[data-element="screens-container"] > div');
      sections.forEach((section) => {
        if (section.dataset.id === key) {
          section.classList.remove('inactive');
        } else {
          section.classList.add('inactive');
        }
      });
    }
  }
}

customElements.define('account-menu', AccountMenu);

/*
Order Tabs
*/

class OrderTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const header = this.querySelector('div');
    const buttons = header.querySelectorAll('button');
    const content = this.querySelector('div:nth-child(2)');

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        buttons.forEach((button) => {
          button.classList.remove('border-black');
          button.classList.add('border-white');
        });
        button.classList.remove('border-white');
        button.classList.add('border-black');
        toggleScreen(index);
      });
    });

    function toggleScreen(index) {
      const screens = content.querySelectorAll('.w-full');
      screens.forEach((screen, i) => {
        if (index == i) {
          screen.classList.remove('hidden');
        } else {
          screen.classList.add('hidden');
        }
      });
    }
  }
}

customElements.define('order-tabs', OrderTabs);

/*
Switch Names
*/

class SwitchNames extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const button = this.querySelector('button');
    this.addEventListener('click', () => {
      if (button.innerHTML.trim() === this.dataset.active) {
        button.innerText = this.dataset.inactive;
      } else {
        button.innerHTML = this.dataset.active;
      }
    });
  }
}
customElements.define('switch-names', SwitchNames);

/*
Site Wishlist Link Generator
*/

class SiteWishlistLinkGenerator extends HTMLElement {
  connectedCallback() {
    this.customerId = this.dataset.customerId;

    this.addEventListener('click', async (e) => {
      const button = e.target.closest('button');
      if (!button) return;

      if (!this.customerId) {
        window.location.href = '/account/login';
        return;
      }

      const launchNewWindow = (link) => {
        const top = window.innerHeight / 2;
        const left = window.innerWidth / 1.75;
        window.open(
          link,
          '',
          `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600,top=${top},left=${left}`,
        );
      };

      const wishlistLink = await this.getWishlistLink();

      if (button.matches('.copy-link')) {
        navigator.clipboard.writeText(wishlistLink).then(() => {
          showSiteToast('Copied to clipboard');
        });
      }

      if (button.matches('.facebook-link')) {
        const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${wishlistLink}`;
        launchNewWindow(fbUrl);
      }

      if (button.matches('.x-link')) {
        const twUrl = `https://twitter.com/intent/tweet?url=${wishlistLink}`;
        launchNewWindow(twUrl);
      }

      if (button.matches('.email-link')) {
        const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&body=${encodeURIComponent(wishlistLink)}`;
        window.open(gmailUrl, '_blank'); // Opens Gmail compose in a new tab
      }
    });
  }

  async getWishlistLink() {
    const res = await fetch(
      `https://beachriot-wishlist-app.vercel.app/api/beach-riot/wishlist/${this.customerId}/get-share-url`,
    );
    const data = await res.json();
    return `${window.location.origin}/pages/wishlist?id=${encodeURIComponent(
      data.data.shareUrl.replace('/pages/wishlist?id=', ''),
    )}`;
    navigator.clipboard.writeText();
  }
}

customElements.define('site-wishlist-link-generator', SiteWishlistLinkGenerator);

/*
Wishlist Filters (client-side; the wishlist has no collection scope to fetch against)
*/

const WISHLIST_FILTER_GROUPS = {
  'product type': 'Product Type',
  producttype: 'Product Type',
  color: 'Color',
  'filter color': 'Color',
  fabric: 'Fabric',
  size: 'Size',
};

class WishlistFilters extends HTMLElement {
  connectedCallback() {
    this.openBtn = this.querySelector('[data-open-filters]');
    this.closeBtn = this.querySelector('[data-close-filters]');
    this.overlay = this.querySelector('[data-filters-overlay]');
    this.drawer = this.querySelector('[data-filters-drawer]');
    this.filtersTarget = this.querySelector('[data-filters-target]');
    this.pillButtons = Array.from(this.querySelectorAll('[data-pill]'));
    this.selectedFiltersRow = this.querySelector('[data-selected-filters]');
    this.selectedFiltersChips = this.querySelector('[data-selected-filters-chips]');
    this.clearFiltersBtn = this.querySelector('[data-clear-filters]');

    this.activeTags = new Set();
    this.activePills = new Set();

    this.refresh();
    this.bindEvents();
  }

  // Re-scans the grid's cards and rebuilds the filter groups from their
  // data-tags. Call again after cards are injected asynchronously (e.g. the
  // guest wishlist page, which loads cards via fetch instead of Liquid).
  refresh() {
    this.cards = Array.from(this.querySelectorAll('[data-wishlist-grid] .product-item-small-js'));
    this.tagCheckboxes = new Map();

    // Normalize each card's tags to "<Group Label>:<value>" once, so a checkbox
    // matches regardless of the raw tag's prefix casing on a given product.
    this.cardNormalizedTags = new Map(
      this.cards.map((card) => [
        card,
        new Set(
          (card.dataset.tags || '')
            .split(',')
            .map((tag) => tag.trim())
            .filter((tag) => tag.includes(':'))
            .map((tag) => {
              const [rawPrefix, value] = tag.split(':').map((part) => part.trim());
              const label = WISHLIST_FILTER_GROUPS[rawPrefix.toLowerCase()];
              return label && value ? `${label}:${value}` : null;
            })
            .filter(Boolean),
        ),
      ]),
    );

    this.renderFilterGroups();
    this.applyFilters();
  }

  renderFilterGroups() {
    const groups = {};
    this.cardNormalizedTags.forEach((tags) => {
      tags.forEach((tag) => {
        const [label, value] = tag.split(':');
        if (!groups[label]) groups[label] = new Set();
        groups[label].add(value);
      });
    });

    this.filtersTarget.innerHTML = '';

    Object.keys(groups).forEach((label) => {
      const details = document.createElement('details');
      details.className = 'filter-group border-b border-gray';

      const summary = document.createElement('summary');
      summary.className = 'flex items-center justify-between py-4 px-6 cursor-pointer font-body-bold uppercase text-xs';
      summary.textContent = label;
      details.appendChild(summary);

      const optionsWrap = document.createElement('div');
      optionsWrap.className = 'flex flex-col gap-3 px-6 pb-4';

      Array.from(groups[label])
        .sort()
        .forEach((value) => {
          const tag = `${label}:${value}`;
          const optionLabel = document.createElement('label');
          optionLabel.className = 'flex items-center gap-2 cursor-pointer text-sm';

          const input = document.createElement('input');
          input.type = 'checkbox';
          input.value = tag;
          input.addEventListener('change', () => {
            input.checked ? this.activeTags.add(tag) : this.activeTags.delete(tag);
            this.applyFilters();
            this.renderSelectedFilters();
          });
          this.tagCheckboxes.set(tag, input);

          optionLabel.append(input, document.createTextNode(value));
          optionsWrap.appendChild(optionLabel);
        });

      details.appendChild(optionsWrap);
      this.filtersTarget.appendChild(details);
    });
  }

  applyFilters() {
    this.cards.forEach((card) => {
      const tags = this.cardNormalizedTags.get(card);
      const matchesTags = this.activeTags.size === 0 || Array.from(this.activeTags).every((tag) => tags.has(tag));
      const matchesLastUnits = !this.activePills.has('last-units') || card.dataset.lastUnits === 'true';
      const matchesOnSale = !this.activePills.has('on-sale') || card.dataset.onSale === 'true';
      const visible = matchesTags && matchesLastUnits && matchesOnSale;
      card.closest('.col-span-1').classList.toggle('hidden', !visible);
    });
  }

  renderSelectedFilters() {
    if (!this.selectedFiltersRow) return;

    if (this.activeTags.size === 0) {
      this.selectedFiltersRow.classList.add('hidden');
      return;
    }

    this.selectedFiltersRow.classList.remove('hidden');
    this.selectedFiltersChips.innerHTML = '';

    this.activeTags.forEach((tag) => {
      const value = tag.split(':')[1];
      const chip = document.createElement('span');
      chip.className = 'filter-chip';

      const text = document.createElement('span');
      text.textContent = value;

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.setAttribute('aria-label', `Remove ${value} filter`);
      removeBtn.textContent = '×';
      removeBtn.addEventListener('click', () => {
        this.activeTags.delete(tag);
        const checkbox = this.tagCheckboxes.get(tag);
        if (checkbox) checkbox.checked = false;
        this.applyFilters();
        this.renderSelectedFilters();
      });

      chip.append(text, removeBtn);
      this.selectedFiltersChips.appendChild(chip);
    });
  }

  clearAllFilters() {
    this.activeTags.clear();
    this.tagCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
    this.applyFilters();
    this.renderSelectedFilters();
  }

  bindEvents() {
    this.openBtn?.addEventListener('click', () => this.openDrawer());
    this.closeBtn?.addEventListener('click', () => this.closeDrawer());
    this.overlay?.addEventListener('click', () => this.closeDrawer());
    this.clearFiltersBtn?.addEventListener('click', () => this.clearAllFilters());

    this.pillButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.pill;
        const isActive = btn.classList.toggle('active');
        btn.querySelector('.pill-check')?.classList.toggle('hidden', !isActive);
        isActive ? this.activePills.add(key) : this.activePills.delete(key);
        this.applyFilters();
      });
    });
  }

  openDrawer() {
    this.drawer.classList.add('is-open');
    this.overlay.classList.remove('hidden');
  }

  closeDrawer() {
    this.drawer.classList.remove('is-open');
    this.overlay.classList.add('hidden');
  }
}

customElements.define('wishlist-filters', WishlistFilters);

/*
Adresses Manager
*/

class Addresses extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const editBtn = this.querySelector('.edit-button');
    const editForm = document.querySelector('.edit-form');
    const addressesContainer = document.querySelector('.addresses-container');
    const cancelBtn = this.querySelector('.cancel-button');

    editBtn.addEventListener('click', () => {
      addressesContainer.classList.toggle('hidden');
      editForm.classList.toggle('hidden');
    });

    cancelBtn.addEventListener('click', () => {
      addressesContainer.classList.toggle('hidden');
      editForm.classList.toggle('hidden');
    });
  }
}

customElements.define('address-item', Addresses);

/*
Order History
*/

class OrderHistory extends HTMLElement {
  constructor() {
    super();
    this.openOrder();
  }

  openOrder() {
    const viewBtn = this.querySelector('.view-order');
    const orderContainer = this.querySelector('.order-container');
    viewBtn.addEventListener('click', () => {
      if (!viewBtn.classList.contains('active')) {
        viewBtn.classList.add('active');
        orderContainer.classList.remove('hidden');
        orderContainer.classList.remove('lg:hidden');
        setTimeout(() => {
          orderContainer.classList.remove('opacity-0');
        }, 100);
      } else {
        viewBtn.classList.remove('active');
        orderContainer.classList.add('opacity-0');
        setTimeout(() => {
          orderContainer.classList.add('hidden');
          orderContainer.classList.add('lg:hidden');
        }, 100);
      }
    });
  }
}
customElements.define('order-history', OrderHistory);
